<template>
    <div class="monitoringSimpleValue">
        <label><slot></slot></label>
        <span :data-status="status">{{ value }}</span>
    </div>
</template>

<script>
export default {
  props: [
    'value',
    'status'
  ]
}
</script>

<style>
.monitoringSimpleValue{
  margin-bottom:1px;
  line-height:14px
}
.monitoringSimpleValue span{
  margin-left:5px;
  padding:1px 3px;
  color:grey
}
.monitoringSimpleValue span[data-status="2"]{
  color:green
}
.monitoringSimpleValue span[data-status="1"]{
  color:orange
}
.monitoringSimpleValue span[data-status="0"]{
  color:red
}
</style>
